import { ActionType, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { fetchLookDetailPageSliderActions } from '../lookDetail/actions';
import { LooksSliderResponse } from './types';

export const fetchLooksSliderActions = createAsyncAction(
    '@LOOKS_SLIDER/FETCH_START',
    '@LOOKS_SLIDER/FETCH_SUCCESS',
    '@LOOKS_SLIDER/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<LooksSliderResponse>, DefaultErrorPayload>();

export const LOOKS_SLIDER_IDENTIFIER = 'looks_slider';
export const LOOKS_SLIDER_LDP_IDENTIFIER = 'looks_slider_ldp';

export const fetchLooksSliderIfNeeded = (
    ldp = false,
    identifier = LOOKS_SLIDER_IDENTIFIER
): DataFetchingThunkAction => async (dispatch, getState, { apiService, logger }) => {
    if (!ldp && identifier === getState().looksSlider.identifier) {
        return;
    }
    if (ldp && identifier === getState().lookDetailPage.looksSlider.identifier) {
        return;
    }
    const actions = ldp ? fetchLookDetailPageSliderActions : fetchLooksSliderActions;

    dispatch(actions.request({ identifier }));
    try {
        const params = ldp ? { slug: identifier } : {};
        const looksSlider = await apiService.shopApi.getLooksSlider(params);
        dispatch(actions.success({ data: looksSlider, identifier }));
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchLooksSliderIfNeeded');
        dispatch(actions.failure({ error: err, identifier }));
    }
};

export type LooksSliderActionsType = ActionType<typeof fetchLooksSliderActions>;
